import React, {Component} from 'react';
import AUX from '../../hoc/Aux_';
import MUIDataTable from "mui-datatables";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import BorderColorTwoToneIcon from '@material-ui/icons/BorderColorTwoTone';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { Alert, AlertTitle } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import AddData3d from './AddData3d';

import Dialog from '@material-ui/core/Dialog';
import DialogDetail from '../../components/Kugi/dialogdetail';

import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Link } from 'react-router-dom';

import { fetchCatalog , fetchUnsur} from '../../api/featurecatalog';
import { deleteFeatureType } from '../../api/kugi';
import {pushSelectedCategory} from '../../actions/general';
import { connect } from 'react-redux';

class Data3d extends Component{

  constructor(props) {
    super(props);
    this.state = {
      selected: 1,
      fetchType : [],
      category: [],
      open : false,
      fcid: 1,
      featureCatalog: [],
      dataUpdate: []
    }
  }

  componentWillMount(){
    if(localStorage.getItem('token')==null){
      console.log(localStorage.getItem('token'));
      this.props.history.push(`/login`);
    }
    fetchUnsur(this.state.selected)
      .then(response => {
        console.log(response.data);
        this.setState({fetchType: response.data});

        const arr = [];
        response.data.map((e)=>{
          arr.push(["",e.code, e.typeName, e.definition, e.aliases, e.fcDefinitionSource, e.role, e.ptCardinality, e.ptDefinition, e.kode, e.featureTypeID]);

        })

        this.setState({category:arr});

      }).catch(error => {
        console.log(error);
      });

    fetchCatalog()
      .then(response => {
        this.setState({featureCatalog: response.data});

      }).catch(error => {
        console.log(error);
      });
  }

  handleDelete = (e) => {

    let ftid = this.state.category[e.data[0].index][9].replace("@en", "");
    deleteFeatureType(ftid)
      .then(response => {
        console.log("deleted");
      })
      .catch(error => {
        console.log(error);
      });
  }

  handleChange = (e)=>{
    console.log(e.target.value);
    this.setState({selected:e.target.value, categorySelected: e.target.value });
    this.props.pushSelectedCategory(e.target.value);
    fetchUnsur(e.target.value)
      .then(response => {
        console.log(response.data);
        this.setState({fetchType: response.data});

        const arr = [];
        response.data.map((e)=>{
          arr.push([e.code, e.typeName, e.definition, e.aliases, e.fcDefinitionSource, e.role, e.ptCardinality, e.ptDefinition, e.kode, e.featureTypeID]);

        })

        this.setState({category:arr});

      }).catch(error => {
        console.log(error);
      });
  }

  handleReload = ()=>{
    fetchUnsur(this.state.selected)
      .then(response => {
        console.log(response.data);
        this.setState({fetchType: response.data});

        const arr = [];
        response.data.map((e)=>{
          arr.push([e.code, e.typeName, e.definition, e.aliases, e.fcDefinitionSource, e.role, e.ptCardinality, e.ptDefinition, e.kode, e.featureTypeID]);

        })

        this.setState({category:arr});

      }).catch(error => {
        console.log(error);
      });
  }

  handleClose = () =>{
    this.setState({open:false});
  }

  renderMenu = (e)=>{
    return (<MenuItem value={e.featureCatalogId.replace("@en", "")}>{e.name.replace("@en", "")}</MenuItem>)
  }

  handleUpdate = (e)=>{
    console.log(e.rowData);
    this.setState({dataUpdate: e.rowData, open: true });

  }

  render(){


    const options = {
      filterType: 'checkbox',
      onRowsDelete: this.handleDelete,
      selectableRows:false
    };

    const columns = [
      {
        name:"Update",
        options: {


         filter: true,
         sort: false,
         customBodyRender: (value, tableMeta, updateValue) => (
           <BorderColorTwoToneIcon color="primary" onClick={event => this.handleUpdate(tableMeta)} style = {{cursor:"pointer"}}/>
         )
        }
      },
      {name:"aliases"},
      {name:"attributVersionNumber"},
      {name:"code"},
      {name:"date"},
      {name:"definition"},
      {name:"faCode"},
      {name:"faValueType"},
      {name:"fcDefinitionReference"},
      {name:"fcDefinitionReference1"},
      {name:"fcFeatureAssociation"},
      {name:"fcName"},
      {name:"fcProducer"},
      {name:"fcProducer1"},
      {name:"featureCatalogue"},
      {name:"featureCatalogueId"},
      {name:"role"},
      {name:"typeName"}
    ];

    return (
      <AUX>
      <Dialog
        open={this.state.open}
        fullScreen
        maxWidth={""}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >

        <DialogTitle disableTypography style = {{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
        >
          <Alert severity="info">Add Data 3D</Alert>
            <IconButton onClick={this.handleClose}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent>
            <AddData3d handleOpen = {this.handleClose}  data = {this.state.dataUpdate} handleReload = {this.handleReload}/>
        </DialogContent>
      </Dialog>

      <section className="sections" style = {{paddingTop:"5%"}}>

      <div className="row justify-content-center" >

      <FormControl variant="outlined" style = {{minWidth: 250}}>
        <InputLabel id="demo-simple-select-label">Choose Feature Catalog</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={this.state.selected}
          onChange={this.handleChange}
        >

          {this.state.featureCatalog.map(this.renderMenu)}
        </Select>
      </FormControl>
      </div>
        <div className="container">

          <MUIDataTable
          title={"Data 3d Feature Type / Unsur"}
          data={this.state.fetchType}
          columns={columns}
          options={options}
          />
          <div className="container">
              <div className="row justify-content-center" id="counter"/>
          </div>
        </div>
      </section>
      </AUX>
    )
  }
}

const mapStatetoProps = state => {

    return {
        categorySelected: state.categorySelected
    };
}


export default connect(mapStatetoProps, {pushSelectedCategory})(Data3d);
